import React, { useEffect, useState } from "react";
import { GoDownload } from "react-icons/go";
import ActionBlueButton from "../../../components/ActionBlueButton";
import InvokeTopBar from "../../../components/InvokeTopBar";
import MarketInvokeTable from "../Tables/MarketInvokeTable";
import TableFooter from "../../../components/TableFooter";
import InitiateInvokeModal from "./InitiateRevokeModal";
import MarginInvokeTable from "../Tables/MarginInvokeTable";
import DpdInvokeTable from "../Tables/DpdInvokeTable";
import RepaymentCompletedTable from "../Tables/RepaymentCompleteTable";
import NotDisbursedTable from "../Tables/NotDisbursedTable";
import InitiateRevokeModal from "./InitiateRevokeModal";
import CancelRevokeModal from "./CancelRevokeModal";
import LogModal from "../LogModal";
import PartialRevokeTable from "./PartialRevokeTable";

function RevokePage() {
  const [invokeSection, setInvokeSection] = useState("repaymentCompleted");
  const [invocationState, setInvocationState] = useState("list");
  const [searchValue, setSearchValue] = useState("");
  const [noOfRows, setNoOfRows] = useState(0);
  const [noOfPages, setNoOfPages] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [invokeCount, setInvokeCount] = useState(0);
  const [initiateModal, setInitiateModal] = useState(false);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [selectedItems, setSelectedItems] = useState([]);
  const [reRender, setReRender] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [revokeModal, setRevokeModal] = useState(false);

  const [partUserView, setPartUserView] = useState(false);
  const invokeFilter = [
    {
      title: "Repayment Completed",
      value: "repaymentCompleted",
    },
    {
      title: "Loan Not Disbursed",
      value: "loanNotDisbursed",
    },
  ];
  useEffect(() => {
    // console.log(searchValue, invocationState, invokeSection);
  }, [searchValue, invocationState, invokeSection]);

  useEffect(() => {
    setSearchValue("");
    setPageNo(1);
    setRowsPerPage(15);
  }, [invocationState, invokeSection]);
  return (
    <div className="  mx-[20px] mt-4 rounded-t-lg">
      <div className=" bg-white px-4 flex flex-col justify-between pt-2 rounded-t-lg">
        <p className=" text-lg font-semibold mb-1">Revoke</p>
        <div className=" text-sm flex justify-between items-center">
          {" "}
          <div className=" flex items-center">
            {invokeFilter.map((filter, index) => (
              <button
                key={index}
                className={`   ${
                  invokeSection === filter.value
                    ? "border-b-[3px] border-[#212b36]  font-semibold "
                    : ""
                }   py-[12px] mr-8`}
                onClick={() => {
                  setPartUserView(false);
                  setInvokeSection(filter.value);
                }}
              >
                <span className=" mr-1">{filter.title}</span>{" "}
                {/* <span className="bg-[#baaeff] text-xs font-bold px-[6px] py-1 rounded-[14px]">
                {" "}
                99
              </span> */}
              </button>
            ))}
            <div className=" h-[28px] bg-[#c8c8c8] w-[1px]  mr-8"></div>
            <button
              className={` border-[#212b36]   ${
                invokeSection === "partial_revoke"
                  ? "border-b-[3px] font-semibold   "
                  : " border-b-[0px]"
              }   py-[12px] } `}
              onClick={() => setInvokeSection("partial_revoke")}
            >
              <span className=" mr-1">Partial Revoke</span>{" "}
              {/* <span className="bg-[#baaeff] text-xs font-bold px-[6px] py-1 rounded-[14px]">
                {" "}
                99
              </span> */}
            </button>
          </div>
          {invokeSection !== "partial_revoke" && (
            <button
              className=" text-sm font-semibold text-[#00394d] "
              onClick={() => setRevokeModal(true)}
            >
              Revoke Logs
            </button>
          )}
        </div>
      </div>
      {/* Invoke Status and search */}
      {invokeSection !== "partial_revoke" && (
        <InvokeTopBar
          invocationState={invocationState}
          setInvocationState={setInvocationState}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          invokeCount={invokeCount}
          setInitiateModal={setInitiateModal}
          setCancelModal={setCancelModal}
          readOnly={readOnly}
        />
      )}

      {invokeSection === "repaymentCompleted" && (
        <RepaymentCompletedTable
          setInvokeCount={setInvokeCount}
          invocationState={invocationState}
          setTotalPages={setNoOfPages}
          setTotalRows={setNoOfRows}
          pageNo={pageNo}
          rowsPerPage={rowsPerPage}
          searchValue={searchValue}
          setEndIndex={setEndIndex}
          setSelectArray={setSelectedItems}
          reRender={reRender}
        />
      )}
      {invokeSection === "partial_revoke" && (
        <PartialRevokeTable
          type="revoke"
          partUserView={partUserView}
          setPartUserView={setPartUserView}
          setTotalPages={setNoOfPages}
          setTotalRows={setNoOfRows}
          pageNo={pageNo}
          rowsPerPage={rowsPerPage}
          searchValue={searchValue}
          setEndIndex={setEndIndex}
          setSelectArray={setSelectedItems}
          reRender={reRender}
          setReRender={setReRender}
          setPageNo={setPageNo}
        />
      )}
      {invokeSection === "loanNotDisbursed" && (
        <NotDisbursedTable
          setInvokeCount={setInvokeCount}
          invocationState={invocationState}
          setTotalPages={setNoOfPages}
          setTotalRows={setNoOfRows}
          pageNo={pageNo}
          rowsPerPage={rowsPerPage}
          searchValue={searchValue}
          setEndIndex={setEndIndex}
          setSelectArray={setSelectedItems}
          reRender={reRender}
          setReRender={setReRender}
        />
      )}
      {!partUserView && (
        <TableFooter
          totalPages={noOfPages}
          totalRows={noOfRows}
          rowsPerPage={rowsPerPage}
          startIndex={startIndex}
          setStartIndex={setStartIndex}
          setEndIndex={setEndIndex}
          endIndex={endIndex}
          setPageNo={setPageNo}
          pageNo={pageNo}
          setRowsPerPage={setRowsPerPage}
        />
      )}

      {initiateModal && (
        <InitiateRevokeModal
          cancelFunction={setInitiateModal}
          selectedItems={selectedItems}
          invocationState={invocationState}
          reRender={reRender}
          setReRender={setReRender}
          setReadOnly={setReadOnly}
        />
      )}
      {cancelModal && (
        <CancelRevokeModal
          cancelFunction={setCancelModal}
          selectedItems={selectedItems}
          setReRender={setReRender}
          reRender={reRender}
        />
      )}
      {revokeModal && (
        <LogModal closeInvokeModal={setRevokeModal} loanAction="revoke" />
      )}
    </div>
  );
}

export default RevokePage;
